export default __webpack_public_path__ + "static/media/Q_Quatro.5112f5b4.mp3";